import { memo, useMemo } from "react";
import TreeView from "@services/components/TreeView";
import TreeViewItem from "@services/components/TreeViewItem";
import { Typography, useTheme } from "@mui/material";
import hex2rgba from "hex2rgba";
import { RouteTo } from "@routing/RouteMap";
import { useLocation, useNavigate } from "react-router-dom";

interface NavItem {
    id: string;
    label: string;
    path: string;
    children?: NavItem[];
}

const WesentlichkeitTreeView = memo(() => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const navigationItems: NavItem[] = useMemo(
        () => [
            {
                id: "analysis-settings",
                label: "Einstellungen zur Analyse",
                path: `${RouteTo.WESENTLICHKEIT}/einstellungen`,
            },
            {
                id: "quick-analysis",
                label: "Wesentlichkeitsanalyse",
                path: `${RouteTo.WESENTLICHKEIT}/analyse/esrs-e1`,
                children: [
                    { id: "esrs-e1", label: "Climate Change", path: `${RouteTo.WESENTLICHKEIT}/analyse/esrs-e1` },
                    { id: "esrs-e2", label: "Umweltverschmutzung", path: `${RouteTo.WESENTLICHKEIT}/analyse/esrs-e2` },
                    { id: "esrs-e3", label: "Wasser- und Meeresressoucen", path: `${RouteTo.WESENTLICHKEIT}/analyse/esrs-e3` },
                    { id: "esrs-e4", label: "Biodiversität & Ökosysteme", path: `${RouteTo.WESENTLICHKEIT}/analyse/esrs-e4` },
                ],
            },
            {
                id: "iro-analysis",
                label: "IRO-Analyse",
                path: `${RouteTo.WESENTLICHKEIT}/iro`,
            },
        ],
        [],
    );

    const getBackgroundColor = (currentPath: string) => 
        (pathname.endsWith(currentPath) || pathname.includes(currentPath + "/") 
        ? hex2rgba(theme.palette.semantic.button.primary, 0.1) 
        : undefined);

    const renderTreeItem = ({ id, label, path, children }: NavItem) => (
        <TreeViewItem
            key={id}
            id={id}
            labelContent={
                <Typography
                    onClick={() => navigate(path)}
                    sx={{
                        px: 2,
                        py: children ? 0.5 : 1,
                        borderRadius: "12px",
                        background: getBackgroundColor(path.split("/").pop() || ""),
                    }}
                >
                    {label}
                </Typography>
            }
        >
            {children?.map(renderTreeItem)}
        </TreeViewItem>
    );

    return <TreeView height="100%">{navigationItems.map(renderTreeItem)}</TreeView>;
});

export default WesentlichkeitTreeView;
